<template>
    <div class="main">

        <div class="top">
            <div class="flex-row header-ctrl">
                <i class="iconfont iconarrowleft-outline" @click="goback" style="font-size: 26px"></i>
            </div>
            <div class="header-info">
                问题反馈
            </div>
        </div>
        <div class="content">
            <div class="info">
                <div class="info-title">
                    亲爱的用户：
                </div>
                <div class="info-main">
                    如您在使用过程中遇到问题，请联系以下人员，我们会尽快处理，感谢您的理解与支持！
                </div>
            </div>

            <div class="flex-row">
                <span class="iconfont iconperson-fill bottom-style"></span><span class="set-name"> PE Community 协调人</span>
            </div>
            <div class="flex-row">
                <div class="contacts">
                    <div>
                        <div class="item" v-for="user in contacts" :key="user.id">
                            <div class="item-img">
                                <van-image width="2rem" height="2.5rem" :src="user.photoBase64" />
                            </div>
                            <div class="item-right">

                                <div class="item-name"><span>{{ user.englishName }}</span>
                                    <div class="item-email">
                                        <a :href="['mailto:' + user.email]">
                                            <span class="icon iconfont iconemail-outline"></span>
                                        </a>
                                    </div>
                                </div>
                                <div>
                                    <span v-text="user.los"></span>
                                    <span class="item-right-sep" v-if="user.city != null ">/</span>
                                    <span v-text="user.city"></span>
                                    <span class="item-right-sep" v-if="user.jobTitle != null ">/</span>
                                    <span v-text="user.jobTitle"></span>
                                    <span class="item-right-sep" v-if="user.officeTel != null ">/ Ext.{{user.officeTel}}</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex-row">
                <span class="iconfont iconperson-fill bottom-style"></span><span class="set-name"> 系统管理员</span>
            </div>

            <div class="flex-row">
                <div class="contacts" style="width:100%;" >
                    <div>
                        <div class="item">
                            <div class="item-img">
                                <van-image width="2rem" height="2.5rem" :src="sysAdmin.photoBase64" />
                            </div>
                            <div class="item-right">

                                <div class="item-name">
                                    <span>{{ sysAdmin.englishName }}</span>
                                    <div class="item-email">
                                        <a :href="['mailto:' + sysAdmin.email]">
                                            <span class="icon iconfont iconemail-outline"></span>
                                        </a>
                                    </div>
                                </div>
                                <div>
                                    <span v-text="sysAdmin.los"></span>
                                    <span class="item-right-sep" v-if="sysAdmin.city != null ">/</span>
                                    <span v-text="sysAdmin.city"></span>
                                    <span class="item-right-sep" v-if="sysAdmin.jobTitle != null ">/</span>
                                    <span v-text="sysAdmin.jobTitle"></span>
                                    <span class="item-right-sep" v-if="sysAdmin.officeTel != null ">/ Ext.{{sysAdmin.officeTel}}</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import webService from "@network/webService";
import _ from "lodash";

export default {
    data() {
        return {
            contacts: [],
            sysAdmin: {},
        };
    },

    components: {},

    computed: {},

    mounted() {
        this.getManagerList();
    },

    methods: {
        goback() {
            this.$router.back(-1);
        },
        getManagerList() {
            webService.getManagerList().then((res) => {
                console.log(res);
                if (res.data) {
                    let _this = this;
                    _.each(res.data, function (item) {
                        if (item.staffId != "CN429833") {
                            _this.contacts.push(item);
                        } else {
                            _this.sysAdmin = item;
                        }
                    });
                }
            });
        },
    },
};
</script>
<style lang='scss' scoped>
@import "../../styles/theme.scss";
.main {
    height: 100%;
}
.content {
    padding: 16px;
}
.top {
    align-items: center;
    height: 50px;
    padding: 0px 10px 0 10px;

    font-size: 25px;
    .header-info {
        color: #2d2d2d;
    }

    .header-ctrl {
        height: 36px;
        font-size: 26px;
    }
}
.content {
    margin-top: 20px;
    .info {
        color: #4a4747;
        margin-bottom: 20px;
        line-height: 28px;
        .info-main {
            text-indent: 2em;
        }
    }
}

.flex-row {
    // color: #7d7d7d;
    margin-top: 10px;
    .set-name{
        margin-left: 6px;
    }
}
.contacts {
    margin-left: 18px;
    width: 100%;
    .item {
        margin-top: 14px;
        .item-img {
            margin-right: 10px;
        }
        .item-right {
            width: 100%;
            .item-name {
                display: flex;
            }
            .item-email {
                flex: 1;
                text-align: right;
            }
            .item-email a {
                color: #2d2d2d;
            }
        }
        display: flex;
        color: #7d7d7d;
        font-size: 12px;
        line-height: 24px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/profile/Feedback.vue